import { shouldNavigate } from '../utils/navigation';
import type { ReactNode } from 'react';
import type { LibraryStats } from '../types';
import { NowPlaying } from './NowPlaying';

interface ShellProps {
  active: string;
  collectionPath?: string;
  stats: LibraryStats;
  generatedAt: string | null;
  onNavigate: (path: string) => void;
  children: ReactNode;
}

const nav = [
  { page: 'explore', path: '/', label: 'Explore', mark: '◉' },
  { page: 'collection', path: '/collection', label: 'Collection', mark: '▥' },
  { page: 'pick', path: '/pick', label: 'Pick', mark: '⤨' },
  { page: 'stats', path: '/stats', label: 'Stats', mark: '▥' },
] as const;

export function Shell({ active, collectionPath = '/collection', stats, generatedAt, onNavigate, children }: ShellProps) {
  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="site-header">
        <div className="site-header__inner">
          <a className="brand" href="/" onClick={(event) => { if (!shouldNavigate(event)) return; event.preventDefault(); onNavigate('/'); }} aria-label="flac.banast.as, Explore">
            <span className="brand-mark" aria-hidden="true"><i /><i /><i /><i /><i /></span>
            <span><strong>flac.banast.as</strong><small>{stats.totalAlbums.toLocaleString()} albums</small></span>
          </a>
          <nav aria-label="Primary navigation">
            {nav.map((item) => <a key={item.page} href={item.page === 'collection' ? collectionPath : item.path} aria-current={active === item.page ? 'page' : undefined} aria-label={item.label} onClick={(event) => { if (!shouldNavigate(event)) return; event.preventDefault(); onNavigate(item.page === 'collection' ? collectionPath : item.path); }}><span aria-hidden="true">{item.mark}</span><b>{item.label}</b></a>)}
          </nav>
        </div>
      </header>
      <NowPlaying />
      <main id="main-content" tabIndex={-1}>{children}</main>
      <footer>
        <p>A public, read-only view of Bill Anastas&apos;s digital music library.</p>
        <p>{generatedAt ? `Library synced ${new Intl.DateTimeFormat('en-US', { dateStyle: 'long', timeStyle: 'short' }).format(new Date(generatedAt))}` : 'Library sync pending'}</p>
      </footer>
    </div>
  );
}
